<template>
    <div>
        <!-- review post aNewItem -->
        <div class="container profile-review-box p-5 my-5">
            <!-- Alert Messages for desktop view -->
            <div v-if="msg !== ''" class="row mb-5 d-none d-md-block">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i :class="`far fa-${emoji}`"></i> {{ msg }}
                    </div>
                </dd>
            </div>
            <!-- before posting item -->
            <template v-if="!itemPosted">
                <!-- stage heading -->
                <div class="row">
                    <div class="col-12">
                        <h3>Review Post</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr>
                    </div>
                </div>
                <!-- item details -->
                <div v-if="anewitem" class="row mt-3">
                    <dt class="col-sm-3 mb-3">Item Title</dt>
                    <dd class="col-sm-9">
                        <p>
                            <span class="text-capitalize">{{anewitem.title}}</span>
                            <span @click="gotoStage2" class="ml-2 edit-stage"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>

                    <dt class="col-sm-3 mb-3">Item Description</dt>
                    <dd class="col-sm-9">
                        <p>
                            {{anewitem.description | capitalize}}
                            <span @click="gotoStage2" class="ml-2 edit-stage"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Item Category</dt>
                    <dd class="col-sm-9">
                        <p>
                            <span class="text-capitalize">{{anewitem.category}}</span> 
                            <span @click="gotoStage2" class="edit-stage ml-2"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Sub Category</dt>
                    <dd class="col-sm-9">
                        <p>
                            <span class="text-capitalize">{{anewitem.subCategory}}</span> 
                            <span @click="gotoStage2" class="edit-stage ml-2"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Item Condition</dt>
                    <dd class="col-sm-9">
                        <p>
                            <span class="text-capitalize">{{anewitem.condition}}</span> 
                            <span @click="gotoStage2" class="edit-stage ml-2"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Item Ref. Url</dt>
                    <dd class="col-sm-9">
                        <p>
                            <a v-if="anewitem.refUrl" :href="anewitem.refUrl" target="_blank" class="text-danger">{{anewitem.refUrl}}</a> 
                            <span v-else>N/A</span> 
                            <span @click="gotoStage2" class="edit-stage ml-2"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Item Price</dt>
                    <dd class="col-sm-9">
                        <p>
                            <span class="text-uppercase mr-2">{{user.currency}} {{anewitem.price | money}}</span> 
                            <label class="text-capitalize"><input type="radio" checked> {{anewitem.priceType}}</label> 
                            <span @click="gotoStage3" class="edit-stage ml-2"><i class="far fa-edit"></i> edit</span>
                        </p>
                    </dd>
                    
                    <dt class="col-sm-3 mb-3">Item Photos</dt>
                    <dd class="col-sm-9">
                        <div v-if="previewArrCheck" class="form-inline mx-auto text-muted">
                            <div v-for="(x,i) in previewArrCheck" :key="i" class="mx-1 preview-box">
                                <template v-if="previewArr.length > 0">
                                    <img :src="x.path" class="rounded preview-img" />
                                    <i v-if="x.main" class="fas fa-check-circle p-1 preview-trash rounded text-dark-green"></i>
                                </template>
                            </div>
                            <span @click="gotoStage1" class="ml-2 edit-stage"><i class="far fa-edit"></i> edit</span>
                        </div>
                    </dd>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr>
                    </div>
                </div>
                <!-- Alert Messages for mobile view -->
                <div v-if="msg !== ''" class="row mb-4 d-md-none">
                    <dd class="col-12">
                        <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                            <i :class="`far fa-${emoji}`"></i> {{ msg }}
                        </div>
                    </dd>
                </div>
                <!-- stage bottom -->
                <div class="row">
                    <div class="offset-lg-8 col-lg-4 offset-md-6 col-md-6 offset-0 col-12">
                        <div class="row">
                            <div class="col-md-4 d-none d-md-block  col-12">
                                <button @click="cancelPosting" class="form-control btn btn-light h3">Cancel</button>
                            </div>
                            <div class="col-md-8 col-12">
                                <button @click.prevent="aNewItem" v-bind="{'disabled' : postDisable}" v-bind:class="{'disabledClass' : postDisable}" 
                                    class="form-control btn btn-dark-green h3">
                                    <span v-if="postDisable">
                                        <i class="fas fa-cog fa-spin"></i> Posting...
                                    </span>
                                    <span v-else>Post Item Now</span>
                                </button>
                            </div>
                            <div class="col-md-4 col-12 d-md-none">
                                <button @click="cancelPosting" class="form-control btn btn-light h3">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- after posting item -->
            <template v-else>
                <div class="row">
                    <div @click="otherPostings" class="col-sm-6 col-12">
                        <div class="card h-100 clickable">
                            <div class="text-center text-muted another-post">
                                <img :src="latestPostPhoto" class="latest-post-photo rounded my-5" :alt="`${user.name}'s latest item post`">
                                <h3 class="m-3">View My Item</h3>
                            </div>
                        </div>
                    </div>
                    <div @click="cancelPosting" class="col-sm-6 col-12">
                        <div class="card h-100 clickable">
                            <div class="text-center text-muted another-post">
                                <i class="fas fa-camera fa-10x my-5"></i>
                                <h3 class="m-3">Post Another Item</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Alert Messages for mobile view -->
                <div v-if="msg !== ''" class="row d-md-none">
                    <dd class="col-12">
                        <div :class="`alert alert-${color} text-center my-3 p-1`" role="alert">
                            <i :class="`far fa-${emoji}`"></i> {{ msg }}
                        </div>
                    </dd>
                </div>
            </template>
        </div>
        
        <!-- display address box -->
        <app-validate-address v-if="showAddress"></app-validate-address>
        
        <!-- display phone number box -->
        <app-validate-phone v-if="showPhone" @skipPhoneFxn="skipPhoneBox"></app-validate-phone>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'
import ValidateAddress from '../settingsParts/ValidateAddress.vue'
import ValidatePhone from '../settingsParts/ValidatePhone.vue'

export default {
    name: "ReviewPost",
    data() {
        return {
            previewArr: [],
            previewImg: '',
            itemPosted: false,
            postDisable: false,
            showAddress: false,
            showPhone: false,
            skipPhone: false,
            items: 1,
            msg: '',
            color: 'danger',
            emoji: 'frown'
        }
    },
    methods: {
        ...mapActions(['destroyNewItemObj', 'postaNewItem']),
        gotoStage1() {
            this.mutateNextStage = true;
            eventBus.gotoStage1(this.mutateNextStage)
        },
        gotoStage2() {
            this.mutateNextStage = true;
            eventBus.gotoStage2(this.mutateNextStage)
        },
        gotoStage3() {
            this.mutateNextStage = true;
            eventBus.gotoStage3(this.mutateNextStage)
        },
        aNewItem() {
            // first check if the user has already updated their address
            if(!this.user.address){ return this.showAddressFxn() }

            // secondly check if the user has already updated their business phone number
            if(!this.user.phone && !this.skipPhone){ return this.showPhoneFxn() }

            // second disable the post item btn to avoid repeated clicks during slow network
            this.postDisable = true

            // proceed with posting new item
            if(JSON.stringify(this.anewitem) !== '{}'){
                let anewitemObj = {
                    userId: this.user._id,
                    shopOwner: this.user.shopOwner,
                    price: this.anewitem.price,
                    donation: this.anewitem.donation,
                    firmPrice: this.anewitem.firmPrice,
                    photos: this.anewitem.photos,
                    title: this.anewitem.title,
                    description: this.anewitem.description,
                    category: this.anewitem.category,
                    subCategory: this.anewitem.subCategory,
                    condition: this.anewitem.condition,
                    refUrl: this.anewitem.refUrl
                }
                this.postaNewItem(anewitemObj)
                .then((data) => {
                    if(!data.error){
                        this.color = "success"
                        this.emoji = "smile"
                        this.itemPosted = true
                        this.destroyNewItemObj().then(() => {}).catch((e) => {})
                    }
                    this.msg = data.msg
                    this.postDisable = false
                }).catch((e) => {
                    this.postDisable = false
                    this.color = "danger"
                    this.emoji = "frown"
                    this.msg = "Something went wrong while posting item. Try agian"
                })
            } 
            else {
                return this.msg = "Give us few minutes while we try to post your item. If I'm still visible after 5mins, try re-posting."
            }
        },
        cancelPosting() {
            this.gotoStage1()
            this.destroyNewItemObj().then(() => {}).catch((e) => {})
        },
        otherPostings() {
            this.$router.push({
                name: 'selling'
            }).catch((e) => {})
            this.destroyNewItemObj().then(() => {}).catch((e) => {})
        },
        showAddressFxn() {
            this.showAddress = true
        },
        showPhoneFxn() {
            this.showPhone = true
        },
        skipPhoneBox() {
            this.skipPhone = true
            this.showPhone = false
        },
    },
    computed: {
        ...mapGetters(['user', 'preview', 'anewitem']),
        previewArrCheck() {
            if(this.previewArr.length > 0){
                return this.previewArr
            }
            return false
        },
        latestPostPhoto() {
            let src = ""
            for(let x=0; x < this.previewArr.length; x++){
                if(this.previewArr[x].main){
                    src = this.previewArr[x].path
                }
            }
            return src
        }
    },
    components: {
        appValidateAddress: ValidateAddress,
        appValidatePhone: ValidatePhone
    },
    created() {
        if(this.preview && this.preview.length > 0){
            this.previewArr = this.preview
        }
        eventBus.$on('hideGhostMode', (value) => {
            this.showAddress = value;
            this.showPhone = value;
        })
    }
}
</script>

<style scoped>
.disabledClass {
    background-color: #95B46A;
}
</style>